import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Typography, Card, CardContent, Table, TableHead, TableBody, TableContainer } from '@material-ui/core'
import moment from 'moment'

import { Losses } from '../../../../types/Order'
import { LossesFiltersContext } from '../../../../context/LossesFiltersContext'
import { GET_LOSSSES_SUMAMARY } from '../../../../queries/losses'
import TableSkeleton from '../../../../components/skeletons/TableSkeleton'
import TRow from './TRow'

export default function LossesSummary (): JSX.Element {
  const { filters } = useContext(LossesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_LOSSSES_SUMAMARY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: filters
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <TableSkeleton />
  if (loading || !data) return <TableSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.lossesTotals) return <p>No data found</p>

  const lossesTotals: Losses[] = data.lossesTotals

  return (
    <Card>
      <CardContent>
      <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Motivos de Perdas ({lossesTotals[0].dateFormat.interval === 'quarter' ? 'Trimestral' : lossesTotals[0].dateFormat.interval === 'month' ? 'Mensal' : 'Diário'})</Typography>
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TRow data={lossesTotals.map(element => element.dateFormat.interval === 'quarter' ? element.date : moment(element.date).format(element.dateFormat.interval === 'day' ? 'DD/MM/YYYY' : 'MM/YYYY'))} classNameValue='bold right' />
            </TableHead>
            <TableBody>
              <TRow title="Pedidos Entregues" data={lossesTotals.map(element => element.delivered)} classNameValue='right green' classNameTitle='left green' />
              <TRow title="Falha: Bloqueado pela Blocklist" data={lossesTotals.map(element => element.failed.AUTOMATIC_BLOCKLIST)} classNameValue='right red' classNameTitle='left red' />
              <TRow title="Falha: Pgto não realiz/negado" data={lossesTotals.map(element => element.failed.PAYMENT_DENIED)} classNameValue='right red' classNameTitle='left red' />
              <TRow title="Falha:  Anti-fraude" data={lossesTotals.map(element => element.failed.AUTOMATIC_ANTIFRAUD)} classNameValue='right red' classNameTitle='left red' />
              <TRow title="Desistência cliente:" data={lossesTotals.map(element => element.cancelled.CANCELLATION_GAVE_UP)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Produto sem estoque" data={lossesTotals.map(element => element.cancelled.CANCELLATION_OUT_OF_STOCK)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Outro" data={lossesTotals.map(element => element.cancelled.CANCELLATION_OTHER)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Suspeita de fraude" data={lossesTotals.map(element => element.cancelled.CANCELLATION_POSSIBLE_FRAUD)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Área não atendida" data={lossesTotals.map(element => element.cancelled.CANCELLATION_AREA_NOT_COVERED)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Tempo entrega ultrapassado" data={lossesTotals.map(element => element.cancelled.CANCELLATION_PAST_DELIVERY_TIME)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Dados cliente incompleto" data={lossesTotals.map(element => element.cancelled.CANCELLATION_LACKING_DATA)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Endereço incorreto" data={lossesTotals.map(element => element.cancelled.CANCELLATION_WRONG_ADDRESS)} classNameValue='right orange' classNameTitle='left orange' />
              <TRow title="Total de pedidos" data={lossesTotals.map(element => { return { quantity: element.delivered.quantity + element.cancelled.total.quantity + element.failed.total.quantity, gmv: element.delivered.gmv + element.cancelled.total.gmv + element.failed.total.gmv } })} classNameValue='bold right blue' classNameTitle='bold right blue' />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}
